import React from 'react';
import { Button } from './ui/button';
import { Phone, Mail } from 'lucide-react';

const FinalCTA = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-teal-600 to-cyan-700 overflow-x-hidden">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">

        <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
          Need reliable support for yourself or a loved one?
        </h2>

        <p className="text-lg sm:text-xl text-teal-100 mb-10 leading-relaxed">
          We are here to help with friendly, flexible, and trusted home support services.
        </p>

        <div className="flex flex-col items-center justify-center gap-4 mb-10 w-full">

          <a href="tel:07475473449" className="flex items-center space-x-3 bg-white rounded-2xl px-6 py-4 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 w-full max-w-sm">
            <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
              <Phone className="w-6 h-6 text-white" />
            </div>
            <div className="text-left min-w-0">
              <p className="text-sm text-slate-500">Call us today</p>
              <p className="text-xl sm:text-2xl font-bold text-teal-600">07475 473 449</p>
            </div>
          </a>

          <a href="mailto:enquiries@aftseniorassistedservices.co.uk" className="flex items-center space-x-3 bg-white rounded-2xl px-6 py-4 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 w-full max-w-sm">
            <div className="w-12 h-12 bg-cyan-600 rounded-full flex items-center justify-center flex-shrink-0">
              <Mail className="w-6 h-6 text-white" />
            </div>
            <div className="text-left min-w-0 flex-1">
              <p className="text-sm text-slate-500">Email us</p>
              <p className="text-sm font-bold text-cyan-600 sm:whitespace-nowrap break-all sm:break-normal">enquiries@aftseniorassistedservices.co.uk</p>
            </div>
          </a>

        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <a href="tel:07475473449" className="w-full sm:w-auto">
            <Button size="lg" className="bg-white text-teal-600 hover:bg-teal-50 px-10 py-6 text-lg font-bold shadow-lg w-full">
              <Phone className="mr-2 w-5 h-5" />
              Call Today
            </Button>
          </a>
          <Button onClick={scrollToContact} size="lg" variant="outline" className="border-2 border-white text-white hover:bg-white/10 px-10 py-6 text-lg w-full sm:w-auto">
            Send a Message
          </Button>
        </div>

        <p className="text-teal-200 font-medium text-base sm:text-lg">
          ⚡ Limited availability — contact us today to arrange support
        </p>

      </div>
    </section>
  );
};

export default FinalCTA;